<template>
  <div>
    <!-- Popup Modal -->
    <pl-dialog
      :title="
        isEditFeedback
          ? 'Edit Saved Feedback Template'
          : 'New Saved Feedback Template'
      "
      @close="closeModal"
      :disableOutsideClick="true"
      :size="'sm'"
    >
      <!-- Model Content and Inputs -->

      <body class="center items-center p-5 flex-grow">
        <textbox
          class="feedback-input center"
          rows="2"
          :maxHeight="100"
          :maxLength="200"
          v-model="feedback_content"
          placeholder=""
          :showSubmitButton="false"
          :fillRemaining="true"
          :keepFocus="Boolean(feedback_content)"
          data-gramm="false"
        >
        </textbox>
      </body>
      <!-- Form Controls -->
      <footer class="flex my-5 center items-center">
        <button
          class="mx-5 px-10 py-2 w-40 hover:bg-gray-200 rounded cursor-pointer text-gray-400 :hover:text-gray-500 font-semibold disabled:opacity-50"
          @click="closeModal"
        >
          Cancel
        </button>
        <button
          class="px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50"
          @click="submitFeedback"
        >
          Create
        </button>
      </footer>
    </pl-dialog>
  </div>
</template>

<script lang="babel">
  import Textbox from 'components/textbox.vue';
  import { EventBus } from 'utils/event-bus';
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        feedback_content: ''
      };
    },
    components: {
      Textbox,
    },
    props: {
      feedbackID: {
        type: String,
        default:''
      },
      feedbackContent:{
        type: String,
        default: ''
      },
      focusOnMounted: {
        type: Boolean,
        default: false,
      },
      isEditFeedback: {
        type: Boolean,
        default: false,
      },
      rtType:{
        type: String,
        default: ''
      },
    },
    computed: {
      ...mapGetters([
        'getCourseDetail',
      ]),
    },
    methods: {
      closeModal() {
        this.$emit('modalFeedbackClosed');
      },
      submitFeedback() {
        const courseID= this.$route.params.courseID;
        if(this.isEditFeedback){
          const feedback_payload = {};
          feedback_payload.id=this.feedback_id;
          feedback_payload.content=this.feedback_content;
          feedback_payload.roundtable_type=this.rtType;
          this.$store.dispatch('updateFeedback', { course_id: courseID, feedback_id: this.feedback_id , text: this.feedback_content, roundtable_type: this.rtType})
            .then(this.$emit('modalFeedbackClosed'))
            .then(EventBus.$emit('toast-msg', 'Success, feedback has been saved.'))
            .catch(console.error);
        } else {
            this.$store.dispatch('saveFeedback', { course_id: courseID, text: this.feedback_content, roundtable_type: this.rtType})
              .then(this.$emit('modalFeedbackClosed'))
              .then(EventBus.$emit('toast-msg', 'Success, feedback has been saved.'))
              .catch(console.error);
        }
      },
    },
    mounted(){
      if (this.focusOnMounted) {
        setTimeout(() => {
          if(this.isEditFeedback){
            this.feedback_id= this.feedbackID;
            this.feedback_content = this.feedbackContent;
          }
        });
      }

    }
  };
</script>
<style scoped lang="stylus">
  .feedback-input
    resize: none;
    width: 500px;
    height: 100px;
    border-radius: 3px;
    border: 1px solid rgba(53, 53, 53, 0.75);
    &:focus
      border-color: pl-primary
</style>



// WEBPACK FOOTER //
// savedFeedbackModal.vue?6e2da34e